import DATA from 'services/constants/Data';
import FORMATS from 'services/constants/Formats';
import HTTP_REQUEST from 'services/constants/HttpRequest';
import UI from 'services/constants/UI';
import AUTH from 'services/constants/Auth';
import ROUTING from 'services/constants/Routing';

export const CONSTANTS = {
    DATA,
    FORMATS,
    HTTP_REQUEST,
    UI,
    AUTH,
    ROUTING,
};
